module.exports = __webpack_public_path__ + "media/assets/images/blog/nosco_common_new_communication_widget-small-c9a14ed7ead202e88d934b9f5bdc1b5e.png";